import http from "@/http-common.js";

class IntegrationsService {

  basePathApiService = "/integrations";
 
  getAll(params) {
    return http.get(this.basePathApiService, params);
  } 

}
export default new IntegrationsService();
